import { render } from "./Clippy.vue?vue&type=template&id=33f05ea5"
import script from "./Clippy.vue?vue&type=script&lang=ts"
export * from "./Clippy.vue?vue&type=script&lang=ts"

import "@/assets/clippy/clippy.css?vue&type=style&index=0&lang=css"
script.render = render

export default script